module.exports = __webpack_public_path__ + "img/hipp-roof.dfbc5514.png";